export const agency = {
  activities: {
    activities: 'Aktivnosti',
    upcomingRenewals: 'Nadolazeći obnavljanja',
    subscriptionActivities: 'Aktivnosti pretplate',
    upcomingDowngradeRequests: 'Nadolazeći zahtjevi za smanjenje',
    serialNumber: 'Ser. broj',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    currentPlan: 'Trenutni plan',
    price: 'Cijena',
    daysLeft: `Preostalo dana`,
    noDataFound: {
      upcomingDowngrades: 'Nadolazeći zahtjevi za smanjenje',
      noUpcomingDowngradesFoundYet: 'Još nisu pronađeni nadolazeći zahtjevi za smanjenje!',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Nadolazeće obnove korisnika',
      subscriptionActivities: 'Aktivnosti pretplate',
      upcomingDowngradeRequestsOfCustomers: 'Nadolazeći zahtjevi za smanjenje korisnika',
      serialNumber: 'Ser. broj',
      customerEmail: 'Email korisnika',
      customerPhoneNumber: 'Broj telefona korisnika',
      currentPlanOfCustomer: 'Trenutni plan korisnika',
      currentPlanPrice: 'Cijena trenutnog plana',
      daysLeft: `Preostalo dana trenutnog plana korisnika`
    },
  },
  configuration: {
    configurationsHeader: 'Konfiguracije',
    emailHeader: 'Email',
    razorPayHeader: 'RazorPay',
    invoiceDetailsHeader: 'Detalji računa',
    stripeHeader: 'Stripe',
    retentionPolicyHeader: 'Politika zadržavanja',
    zohoHeader: 'Zoho',
    appTooltip: {
      integrateYourEmailProviderDetails: 'Integrirajte detalje svog pružatelja usluga e-pošte kako biste bez problema slali e-poštu kupcima.',
      enterYourRazorPayAccountDetails: 'Unesite detalje svog RazorPay računa za besprijekoran proces plaćanja od strane kupaca.',
      enterYourStripeAccountDetails: 'Unesite detalje svog Stripe računa za besprijekoran proces plaćanja od strane kupaca.',
      enterYourCompanyDetails: 'Unesite detalje svoje tvrtke za točno fakturiranje i profesionalno generiranje računa.',
      enterYourZohoKeys: 'Unesite svoj Zoho Client ID i Zoho Client Secret Key za uspješnu integraciju.',
      enterYourGoogleKeys: 'Unesite svoj Google Client ID i Google Client Secret Key za uspješnu integraciju.',
      retentionPolicyDescription: 'Politika zadržavanja osmišljena je za upravljanje životnim ciklusom podataka unutar sustava.',
    },

    email: {
      testEmail: 'Test Email',
      addEmailIntegrationsDetails: 'Dodajte detalje integracije e-pošte',
      integrationDescription: 'Da biste integrirali detalje svog pružatelja e-pošte, molimo vas da pružite informacije o svom pružatelju e-pošte.' +
        ' Sve komunikacijske e-pošte bit će poslane vašim kupcima putem ove e-adrese, osiguravajući dosljednu i' +
        ' pouzdanu dostavu važnih obavijesti i ažuriranja.',
      awsRegion: 'AWS Regija',
      awsAccessKeyId: 'AWS Identifikacijski ključ pristupa',
      awsSecretAccessKey: 'AWS Tajni pristupni ključ',
      reset: 'Poništi',
      addDetails: 'Dodaj Detalje',
      updateDetails: 'Ažuriraj Detalje',
      fromEmail: 'Da e-mail',
      appTooltip: {
        TOOLTIP_AWS_REGION: 'Unesite svoju AWS regiju. Regija određuje fizičku lokaciju vaših resursa i utječe na faktore poput latencije podataka i pridržavanja propisa.',
        TOOLTIP_AWS_ACCESS_KEY_ID: 'Unesite svoj AWS identifikacijski ključ pristupa. Ovaj ključ jedinstveno identificira vaš AWS račun i potreban je za sigurnu autentifikaciju i pristup AWS uslugama.',
        TOOLTIP_AWS_SECRET_ACCESS_KEY_ID: 'Unesite svoj tajni pristupni ključ AWS-a. Ovaj ključ koristi se za sigurnu autentifikaciju i pristup AWS uslugama.',
        fromEmail: 'E-mail chì serà utilizatu per mandà tutte e-mail di a piattaforma (per esempiu, e-mail di punta, avvisi di contu, etc.)'
      },

      placeholders: {
        enterAwsRegion: 'Unesite AWS regiju',
        enterAwsAccessKeyId: 'Unesite AWS identifikacijski ključ pristupa',
        enterAwsSecretAccessKey: 'Unesite tajni pristupni ključ AWS-a',
        enterFromEmail: 'Entra da email'
      },

      modal: {
        deleteEmailIntegration: 'Izbriši integraciju e-pošte',
        wantToDeleteEmailIntegration: 'Jeste li sigurni da želite izbrisati ovu integraciju e-pošte?',
      },

    },

    facebook: {
      addFacebookIntegrationsDetails: 'Dodaj detalje integracije s Facebookom',
      integrateYourEmailProviderDetails: 'Integrirajte detalje svog pružatelja usluga e-pošte. Sve e-pošte će se slati korisnicima putem ove adrese e-pošte.',
      facebookAppId: 'Facebook App Id',
      facebookSecretAccessKey: 'Facebook Secret Access Key',
      reset: 'Ponovno postavi',
      cancel: 'Otkaži',
      addDetails: 'Dodaj detalje',
      updateDetails: 'Ažuriraj detalje',
      delete: 'Izbriši',
      testEmail: 'Testiraj Email',
      modal: {
        deleteFacebookIntegration: 'Izbriši integraciju s Facebookom',
        wantToDeleteFacebookIntegration: 'Jeste li sigurni da želite izbrisati ovu integraciju s e-poštom?',
      },
      placeholders: {
        enterFacebookAccessKeyId: 'Unesite tajni ključ za pristup Facebooku',
        enterFacebookAppId: 'Unesite Facebook App ID'
      },
      appTooltip: {
        TOOLTIP_WAITING_MESSAGES: 'Prilagodite poruku kako želite da se pojavi na prozoru za chat odmah nakon što bot korisnik pošalje zahtjev za Live Chat',
      }
    },

    invoiceDetails: {
      addInvoiceDetails: 'Dodaj detalje računa',
      invoicesDescription: 'Da biste generirali račune za svoje kupce, molimo vas da pružite detalje o tvrtki, uključujući naziv tvrtke,' +
        'adresu, kontaktne informacije i sve ostale relevantne informacije potrebne za točno fakturiranje.' +
        'Ove informacije će se koristiti za izradu profesionalnih računa u ime vaše tvrtke za svaku transakciju.',
      companyName: 'Naziv tvrtke',
      country: 'Država',
      selectCountry: 'Odaberite državu',
      stateOrRegion: 'Županija/Region',
      streetAddress: 'Adresa',
      gstin: 'GSTIN',
      postalCode: 'Poštanski broj',
      addDetails: 'Dodaj detalje',
      updateDetails: 'Ažuriraj detalje',
      reset: 'Ponovno postavi',
      delete: 'Izbriši',
      loadMore: 'Učitaj više',
      time: 'Vrijeme',
      phoneNumber: 'Broj telefona',
      email: 'Email',
      status: 'Status',
      message: 'Poruka',
      response: 'Odgovor',
      placeOfSupply: 'Mjesto isporuke',
      placeholders: {
        enterYourCompanyName: 'Unesite naziv svoje tvrtke',
        enterYourStateOrRegion: 'Unesite svoju županiju/region',
        enterYourStreetAddress: 'Unesite svoju adresu',
        enterYourGstin: 'Unesite svoj GSTIN',
        enterPostalCode: 'Unesite poštanski broj',
        enterPlaceOfSupply: 'Unesite mjesto isporuke'
      },
      modal: {
        deleteEmailIntegration: 'Izbriši integraciju e-pošte',
        wantToDeleteEmailIntegration: 'Jeste li sigurni da želite izbrisati ovu integraciju e-pošte?',
      },
      appTooltip: {
        TOOLTIP_COMPANY_NAME:
          'Unesite naziv svoje tvrtke. Ove informacije će se koristiti u identifikacijske'
          + ' i brendirajuće svrhe na računima.',
        TOOLTIP_COUNTRY: 'Odaberite svoju državu. Ove informacije će se koristiti u identifikacijske i'
          + 'brendirajuće svrhe na računima.',
        TOOLTIP_STATE: 'Unesite svoju županiju/region. Ove informacije će se koristiti u ' +
          'identifikacijske i brendirajuće svrhe na računima.',
        TOOLTIP_STREET_ADDRESS: 'Unesite svoju adresu. Ove informacije će se koristiti u ' +
          'identifikacijske i brendirajuće svrhe na računima.',
        TOOLTIP_GSTIN: 'Unesite svoj GSTIN. Ove informacije će se koristiti u identifikacijske ' +
          ' i brendirajuće svrhe na računima.',
        TOOLTIP_POSTAL_CODE: 'Unesite svoj poštanski broj. Ove informacije će se koristiti u ' +
          'identifikacijske i brendirajuće svrhe na računima.',
        TOOLTIP_PLACE_OF_SUPPLY: 'Unesite mjesto isporuke. Ove informacije će se koristiti u' +
          ' identifikacijske i brendirajuće svrhe na računima.',
      }
    },

    razorPay: {
      addRazorPayIntegrationsDetails: 'Dodajte RAZORPAY detalje integracije',
      integrationDescription: 'Kako biste integrirali detalje svog RazorPay računa, molimo vas da pružite informacije o svom RazorPay računu.' +
        ' Sve uplate kupaca će biti procesuirane putem vašeg RazorPay računa za besprijekorne transakcije',
      razorPayAccessKeyId: 'RAZORPAY identifikacijski ključ pristupa',
      razorPaySecretAccessKey: 'RAZORPAY tajni pristupni ključ',
      reset: 'Ponovno postavi',
      addDetails: 'Dodaj detalje',
      updateDetails: 'Ažuriraj detalje',
      loadMore: 'Učitaj više',
      time: 'Vrijeme',
      phoneNumber: 'Broj telefona',
      email: 'Email',
      status: 'Status',
      message: 'Poruka',
      response: 'Odgovor',
      placeholders: {
        enterRazorPayAccessKeyId: 'Unesite identifikacijski ključ pristupa Razorpay',
        enterRazorPaySecretAccessKey: 'Unesite tajni pristupni ključ Razorpay',
        enterRazorPayAccessId: 'Unesite identifikacijski ključ pristupa RazorPay',
      },
      appTooltip: {
        TOOLTIP_RAZORPAY_ID: 'Unesite svoj identifikacijski ključ pristupa Razorpay. Ovaj ključ jedinstveno identificira vašu integraciju' +
          ' s Razorpay i potreban je za sigurne transakcije plaćanja.',
        TOOLTIP_RAZORPAY_SECRET_KEY: 'Unesite svoj tajni pristupni ključ Razorpay. Ovaj ključ je ključan za sigurnu komunikaciju između' +
          'aplikacije i Razorpay-a, omogućujući besprijekorno procesuiranje transakcija i upravljanje plaćanjima.',
      },
      modal: {
        deleteRazorPayIntegration: 'Izbriši integraciju e-pošte',
        wantToDeleteThisIntegrtion: 'Jeste li sigurni da želite izbrisati ovu integraciju e-pošte?',
      }
    },

    stripe: {
      addStripeIntegrationDetails: 'Dodajte detalje integracije s Stripe',
      integrationDescription: 'Kako biste integrirali detalje svog Stripe računa, molimo vas da pružite informacije o svom Stripe računu.' +
        ' Sve uplate kupaca će biti procesuirane putem vašeg Stripe računa za besprijekorne transakcije',
      stripeSecretAccessKey: 'Tajni pristupni ključ za pristup Stripeu',
      stripePublicKey: 'Javni ključ za pristup Stripeu',
      reset: 'Ponovno postavi',
      addDetails: 'Dodaj detalje',
      updateDetails: 'Ažuriraj detalje',
      cancel: 'Odustani',
      loadMore: 'Učitaj više',
      time: 'Vrijeme',
      phoneNumber: 'Broj telefona',
      email: 'Email',
      status: 'Status',
      message: 'Poruka',
      response: 'Odgovor',
      placeholders: {
        enterStripeSecretAccessKey: 'Unesite tajni pristupni ključ Stripea',
        enterStripePublicKey: 'Unesite javni ključ Stripea',
      },
      appTooltip: {
        TOOLTIP_STRIPE_SECRET_KEY: 'Unesite svoj tajni pristupni ključ Stripea. Ovaj ključ se koristi za sigurnu autentifikaciju vaše' +
          ' integracije sa Stripeom i potreban je za obradu plaćanja kupaca.',
        TOOLTIP_PUBLIC_KEY: 'Unesite svoj javni ključ Stripea. Ovaj ključ se koristi za sigurnu autentifikaciju vaše integracije s' +
          ' Stripeom na strani klijenta i potreban je za obradu plaćanja kupaca.',
      },
      modal: {
        deleteStripeIntegration: 'Izbriši integraciju s Stripeom',
        wantToDeleteStripeIntegration: 'Jeste li sigurni da želite izbrisati ovu integraciju s Stripeom?',
      }
    },
    retentionPolicy: {
      retentionPolicy: 'Politika zadržavanja',
      retentionPolicyDescription: 'Politika zadržavanja osmišljena je za upravljanje životnim ciklusom podataka unutar sustava, određujući koliko dugo se podaci trebaju čuvati prije nego što se sustavno i sigurno uklone. Ova politika ima za cilj osigurati usklađenost s propisima o zaštiti podataka, optimizirati resurse za pohranu i upravljati podacima na učinkovit i organiziran način.',
      apiLogs: 'Dani zadržavanja API zapisa',
      selectApiLogs: 'Odaberite dane zadržavanja zapisnika API-ja',
      update: 'Ažuriraj',
      save: 'Uštedjeti',
      day: 'dan',
      days: 'dana',
      placeholders: {
        enterNumberOfDays: 'Unesite broj dana'
      }
    },
    zoho: {
      addZohoIntegrationDetails: 'Dodajte pojedinosti integracije Zohoa',
      zohoDescription: `Povežite svoju chatbot platform  sa Zoho CRM-om, Zoho Projects i Zoho Desk bez napora. To će omogućiti vašim korisnicima da automatski prenesu podatke o potencijalnim kupcima koje je uhvatio njihov chatbot i kreiraju zadatke u odgovarajućim Zoho modulima. Da biste započeli uspješnu integraciju, navedite svoj ID Zoho klijenta i tajni ključ Zoho klijenta.`,
      zohoClientId: 'ID Zoho klijenta',
      zohoClientSecret: 'Zoho tajna klijenta',
      zohoCrmExtensionUrl: 'URL Zoho CRM proširenja',
      add: 'Dodati',
      update: 'Ažuriraj',
      placeholders: {
        enterZohoClientId: 'Unesite svoj Zoho ID klijenta',
        enterZohoClientSecret: 'Unesite svoj Zoho tajni ključ klijenta',
        enterZohoCrmExtensionUrl: 'Unesite url vašeg zoho crm proširenja'
      }
    },
    google: {
      addGoogleIntegrationDetails: 'Dodajte detalje integracije s Googleom',
      googleDescription: `Povežite svoj Final_Brand s Google zadacima, Google kontaktima, Google kalendarom, Google tablicama i Google Analytics-om bez napora. To omogućuje korisnicima postavljanje automatizacije radnog tijeka prijenosom podataka uhvaćenih chatbotom u omiljene Google aplikacije. Za pokretanje uspješne integracije, navedite svoj Google Client ID i Google Client Secret Key.`,
      googleClientId: 'Google Client ID',
      googleClientSecret: 'Google Client Secret',
      add: 'Dodaj',
      update: 'Ažuriraj',
      placeholders: {
        enterGoogleClientId: 'Unesite svoj Google Client ID',
        enterGoogleClientSecret: 'Unesite svoj Google Client Secret',
      }
    },

  },
  customer: {
    manageCustomers: 'Upravljanje kupcima',
    addNewCustomers: 'Dodaj nove kupce',
    ensureYouHaveAddedAllYourCustomersHere: `Provjerite jeste li dodali sve svoje kupce ovdje`,
    customerName: 'Ime kupca',
    nameIsRequired: 'Ime je obavezno',
    emailId: 'Email ID',
    enterAValidEmail: 'Unesite valjanu email adresu',
    createPassword: 'Kreirajte lozinku',
    enterAStrongPassword: 'Unesite jaku lozinku',
    confirmPassword: 'Potvrdi lozinku',
    cancel: 'Odustani',
    customer: 'Kupac',
    searchByNameOrEmail: 'Pretraži po imenu ili emailu',
    filters: 'Filteri',
    allCustomers: 'Svi kupci',
    paidCustomers: 'Plaćeni kupci',
    freeCustomers: 'Besplatni kupci',
    messageAddOnCustomers: 'Kupci dodatka poruka',
    botWhiteLabelCustomers: 'Kupci bot bijele oznake',
    sortBy: 'Sortiraj po',
    sortByFrequency: 'Sortiraj po frekvenciji',
    all: 'Svi',
    joinedDate: 'Datum pridruživanja',
    plan: 'Plan',
    lastLogin: 'Zadnja prijava',
    email: 'Email',
    nextDue: 'Sljedeći rok',
    frequency: 'Frekvencija',
    clearAll: 'Očisti sve',
    apply: 'Primijeni',
    messageConsumed: 'Potrošena poruka',
    addCustomer: 'Dodaj kupca',
    serialNumber: 'Ser. broj',
    name: 'Ime',
    contact: 'Kontakt',
    limit: 'Limit',
    location: 'Lokacija',
    actions: 'Radnje',
    joinedOn: 'Pridružen na',
    typeOfCustomer: 'Vrsta kupca',
    exceptWhatsapp: ' (Izuzimajući Whatsapp)',
    exceptWA: '(Izuzimajući WA)',
    wa: '(WA)',
    loadMore: 'Učitaj više',
    conversationsWhatsapp: ' Razgovori (Whatsapp)',
    appTooltip: {
      enterCustomerEmail: 'Unesite email kupca',
      enterCustomerPassword: 'Unesite lozinku kupca',
      enterCustomerConfirmPassword: 'Unesite potvrdnu lozinku kupca',
      enterCustomerName: 'Unesite ime kupca',
    },
    placeholders: {
      enterCustomerEmail: 'Unesite email kupca',
      searchByNameOrEmail: 'Pretraži po imenu ili emailu',
      enterPassword: 'Unesite lozinku',
      enterCustomerName: 'Unesite ime kupca',
    }
  },

  dashboard: {
    dashboard: 'Nadzorna ploča',
    overview: 'Pregled',
    totalCustomers: 'Ukupno korisnika',
    paidCustomers: 'Plaćeni korisnici',
    freeCustomers: 'Besplatni korisnici',
    thisWeeksSignUp: `Prijave ovog tjedna`,
    todaysSignUp: `Današnje prijave`,
    totalEarnings: 'Ukupna zarada',
    nA: 'N/A',
    customerName: 'Ime korisnika',
    nameIsRequired: 'Ime je obavezno',
    emailId: 'Email ID',
    enterAValidEmail: 'Unesite valjanu email adresu',
    editCustomer: 'Uredi korisnika',
    recentSignUps: 'Nedavne prijave',
    serialNumber: 'Ser. broj',
    name: 'Ime',
    email: 'Email',
    contact: 'Kontakt',
    plan: 'Plan',
    limit: 'Limit',
    location: 'Lokacija',
    lastLogin: 'Zadnja prijava',
    joinedOn: 'Pridruženo dana',
    actions: 'Radnje',
    exceptWhatsapp: ' (Izuzimajući Whatsapp)',
    messageConsumed: 'Potrošene poruke',
    conversationsWhatsapp: ' Razgovori (Whatsapp)',
    placeholders: {
      enterCustomerName: 'Unesite ime korisnika',
      enterCustomerEmail: 'Unesite email korisnika',
    },
    modal: {
      deleteCustomer: 'Izbriši korisnika',
      areYouSure: 'Jeste li sigurni da želite izbrisati ovog korisnika?'
    }
  },

  downgradeRequests: {
    activites: 'Aktivnosti',
    upcomingRenewals: 'Nadolazeća obnavljanja',
    subscriptionActivities: 'Aktivnosti pretplate',
    upcomingDonwgradeRequests: 'Nadolazeći zahtjevi za smanjenje',
    serialNumber: 'Ser. broj',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    currentPlan: 'Trenutni plan',
    requestedOn: 'Zatraženo dana',
    downgradeOn: 'Smanji dana',
    nA: 'N/A',
    commaMonthly: ', Mjesečno',
    commaYearly: ' , Godišnje',
    noDataFound: {
      downgradeRequests: `Zahtjevi za smanjenje`,
      noDowngradeRequestFound: `Još nisu pronađeni zahtjevi za smanjenje!`,
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Nadolazeće obnove korisnika',
      subscriptionActivities: 'Aktivnosti pretplate',
      upcomingDowngradeOfCustomers: 'Nadolazeći zahtjevi za smanjenje korisnika',
      serialNumber: 'Ser. broj',
      customerEmail: 'Email korisnika',
      customerPhoneNumber: 'Broj telefona korisnika',
      currentPlanOfCustomer: 'Trenutni plan korisnika',
      currentPlanPrice: 'Cijena trenutnog plana',
    }
  },

  emailIntegration: {
    emailIntegration: 'Integracija e-pošte',
    addEmailIntegrationDetails: 'Dodaj detalje integracije e-pošte',
    integrateYourEmailProviderDetails: 'Integrirajte detalje svog pružatelja e-pošte. Sve će e-pošte biti poslane vašim kupcima koristeći ovu e-poštu',
    awsRegion: 'AWS regija',
    awsRegionIsRequired: 'AWS regija je obavezna',
    awsAccessKeyId: 'AWS identifikacijski ključ pristupa',
    awsAccessKeyIdIsRequired: 'AWS identifikacijski ključ pristupa je obavezan',
    awsSecretAccessKey: 'AWS tajni pristupni ključ',
    awsSecretAccessKeyIsRequired: 'AWS tajni pristupni ključ je obavezan',
    cancel: 'Otkazati',
    test: 'Test',
    action: 'Akcija',
    testEmail: 'Testna e-pošta',
    addDetails: 'Dodaj detalje',
    updateDetails: 'Ažuriraj detalje',
    saveDetails: 'Spremi detalje',
    placeholders: {
      enterAwsRegion: 'Unesite AWS regiju',
      enterAwsAccessKeyId: 'Unesite AWS identifikacijski ključ pristupa',
      enterAwsSecretAccessKey: 'Unesite AWS tajni pristupni ključ',
    },
    modal: {
      deleteEmailIntegration: 'Izbriši integraciju e-pošte',
      areYouSure: 'Jeste li sigurni da želite izbrisati ovu integraciju e-pošte?',
    },
    noDataFound: {
      emailIntegration: 'Integracija e-pošte',
      noEmailIntegrationFoundYet: 'Još nema pronađenih integracija e-pošte!'
    }
  },

  subscription: {
    activities: 'Aktivnosti',
    upcomingRenewals: 'Nadolazeći obnavljanja',
    subscriptionActivities: 'Aktivnosti pretplate',
    upcomingDonwgradeRequests: 'Nadolazeći zahtjevi za smanjenje',
    filters: 'Filteri',
    manageActivities: 'Upravljaj aktivnostima',
    sortBy: 'Sortiraj po',
    all: 'Sve',
    upgrades: 'Poboljšanja',
    donwgrades: 'Smanjenja',
    renewals: 'Obnavljanje',
    serialNumber: 'Ser. broj',
    email: 'Email',
    phoneNumber: 'Broj telefona',
    previousPlan: 'Prethodni plan',
    newPlan: 'Novi plan',
    description: 'Opis',
    date: 'Datum',
    nA: 'Nije dostupno',
    upgraded: 'poboljšano',
    commaYearly: ' , Godišnje',
    commaMonthly: ' , Mjesečno',
    noDataFound: {
      noSubscriptionActivitiesFoundYet: 'Još nema pronađenih aktivnosti pretplate!',
      subscriptionsActivities: 'Aktivnosti pretplate',
    },
    appTooltip: {
      upcomingRenewalsOfCustomers: 'Nadolazeće obnove korisnika',
      subscriptionActivities: 'Aktivnosti pretplate',
      upcomingDowngradeRequests: 'Nadolazeći zahtjevi za smanjenje korisnika',
      serialNumber: 'Ser. broj',
      customerEmail: 'Email korisnika',
      customerPhoneNumber: 'Broj telefona korisnika',
      previousPlan: 'Prethodni plan korisnika',
      newPlan: 'Novi plan korisnika',
      description: 'Opis plana',
      typeOfPayment: 'Vrsta plaćanja',
    }
  },

  feedbacks: {
    feedbacks: 'Povratne informacije',
    serialNumber: 'Ser. broj',
    customer: 'Korisnik',
    type: 'Vrsta',
    rating: 'Ocjena',
    reason: 'Razlog',
    description: 'Opis',
    createdAt: 'Stvoreno',
    nA: 'Nije dostupno',
    loadMore: 'Učitaj više',
    dataNotFound: {
      accountAndBotDeletionFeedbacks: 'Povratne informacije o brisanju računa i bota',
      noFeedbacksFoundYet: 'Još nema pronađenih povratnih informacija!',
    },
    appTooltip: {
      serialNumber: 'Ser. broj',
      customerEmail: 'Email korisnika',
      feedbackForBotOrAccountDeletion: 'Povratne informacije za (Brisanje bota/računa)',
      customerRating: 'Ocjena korisnika',
      customerReason: 'Razlog korisnika',
      feedbackCreatedAt: 'Povratne informacije stvorene',
      customerFeedback: 'Povratne informacije korisnika',
    }
  },
  emailActivity: {
    emailActivityHeading: 'Aktivnost e-pošte',
    heading: 'Vaša aktivnost e-pošte',
    subHeading: 'Zapisnici e-pošte za glavnu agenciju',
    searchLabel: 'Filtrirajte prema imenu kupca',
    customerName: 'Ime kupca',
    emailType: 'Vrsta e-pošte',
    fromEmail: 'S e-pošte',
    toEmail: 'Na e-poštu',
    createdAt: 'Stvoreno',
    action: 'Akcija',
    loadMore: 'Učitaj više',
    noEmailActivityYet: 'Još nema pronađene aktivnosti e-pošte!',
  },
};
